import { createAppTestIds } from './index';

/**
 * Test IDs for Salesforce CRM integration
 */
export const SALESFORCE_TEST_IDS = {
  ...createAppTestIds('salesforce'),

  // Manage modals
  memberManageModal: 'salesforce-member-manage-modal',
  teamManageModal: 'salesforce-team-manage-modal',

  // CRM Autofill settings
  autofill: {
    section: 'salesforce-autofill-section',
    enableToggle: 'salesforce-autofill-enable-toggle',
    fieldMapping: 'salesforce-autofill-field-mapping',
    /**
     * Get test-id for a specific field mapping row
     */
    fieldRow: (fieldName: string) => `salesforce-autofill-field-${fieldName}`,
  },

  // Config rows
  configRow: (index: number) => `salesforce-config-row-${index}`,
} as const;
